import { DialogContent, IconButton, Paper, styled } from "@mui/material"
import Icons from "../../../assets/js/Icons"
import { useSelector } from "react-redux"


const Video = styled("video")(() => ({}))
function Testimonial({ handleClose }) {
  const { data } = useSelector(state => state.otherSlice)

  return (
    <Paper>
      <DialogContent
        className="relative"
        sx={{
          p: 2,
          "textarea": { resize: "none" },
          ".MuiInputBase-root": { borderRadius: "6px" },
        }}
      >
        <IconButton
          size="small"
          onClick={handleClose}
          variant="dialogCloseBtn"
          sx={{
            zIndex: "1",
            color: "grey.50",
            bgcolor: "red.300",
            ":hover": { bgcolor: "red.500" }
          }}
        ><Icons.Cross />
        </IconButton>
        <Video
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "6px",
            objectFit: "contain",
          }}
          controls
          src={data?.src}
        />
      </DialogContent>
    </Paper >
  )
}

export default Testimonial